import { Stack, Typography, Button, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSessionContext } from "@/contexts/SessionContext";

// Importando o ícone do Google Calendar
import CalendarGoogleIcon from "@/assets/CalendarGoogleIcon.png";

interface GoogleAuthCardProps {
  priceInfo?: string;
}

export function GoogleAuthCard({ priceInfo }: GoogleAuthCardProps) {
  const navigate = useNavigate();
  const { user } = useSessionContext();
  const theme = useTheme();

  const handleRedirectToProfile = () => {
    navigate("/profile#info-basicas");
  };

  return (
    <Stack
      sx={{
        border: "1px solid",
        borderColor: "neutral700.main",
        borderRadius: "15px",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
        minHeight: "400px",
        paddingTop: 4,
        paddingBottom: 3,
      }}
    >
      {priceInfo && (
        <Stack
          sx={{
            position: "absolute",
            top: "12px",
            left: "0px",
            bgcolor: "secondary800.main",
            color: "white",
            padding: "4px 12px",
            borderTopRightRadius: "15px",
            borderBottomRightRadius: "15px",
            fontSize: "12px",
            fontWeight: "bold",
            zIndex: 1,
          }}
        >
          {priceInfo}
        </Stack>
      )}
      
      <Stack
        sx={{
          position: "absolute",
          top: "12px",
          right: "0px",
          bgcolor: "success.main",
          color: "white",
          padding: "4px 12px",
          borderTopLeftRadius: "15px",
          borderBottomLeftRadius: "15px",
          fontSize: "12px",
          fontWeight: "bold",
          zIndex: 1,
        }}
      >
        {user.refreshTokenGoogle ? "Ativo" : "Disponível"}
      </Stack>

      <Stack
        direction="row"
        width="100%"
        justifyContent="center"
        marginTop="auto"
        paddingTop={2}
      >
        <Typography
          sx={{
            fontSize: "1.25rem",
            fontWeight: "500",
            paddingBottom: 2,
            paddingLeft: 5,
            paddingRight: 5,
            paddingTop: 1,
            alignSelf: "center",
            textAlign: "center",
            position: "relative",
            zIndex: 0,
          }}
        >
          Google Agenda
        </Typography>
      </Stack>

      <Stack flexGrow={1} overflow="auto" maxHeight="330px">
        <Typography
          variant="body1"
          color="neutral700.main"
          sx={{
            paddingBottom: 1,
            paddingLeft: 5,
            paddingRight: 5,
          }}
          align="left"
        >
          Integre a agenda individual de cada profissional da clínica com o
          Google Agenda. Esta extensão permite que cada profissional,
          individualmente, vincule a sua conta pessoal Fluxmed ao Google Agenda.
          Mantendo o agendamento de seus pacientes sempre atualizadas em ambas
          as plataformas, quando quiser.
        </Typography>

      </Stack>

      <Stack
        direction="row"
        width="100%"
        justifyContent="center"
        marginTop="auto"
        paddingTop={2}
      >
        <Button
            variant="contained"
            sx={{
              width: "70%",
              height: "40px",
            backgroundColor: user.refreshTokenGoogle
              ? "error700.main"
              : "primary700.main",
            color: "white",
            borderRadius: "10px",
            textTransform: "none",
            fontSize: theme.typography.subtitle2.fontSize,
              "&:hover": {
              backgroundColor: user.refreshTokenGoogle
                ? "error800.main"
                : "primary800.main",
            },
          }}
          onClick={handleRedirectToProfile}
          startIcon={
            user.refreshTokenGoogle ? (
              <span style={{ color: "white" }}>⚠️</span>
            ) : (
              <img 
                src={CalendarGoogleIcon} 
                alt="Google Calendar" 
                style={{ height: "30px", width: "auto" }} 
              />
            )
          }
        >
          {user.refreshTokenGoogle
            ? "Desvincular conta google"
            : "Vincular conta google"}
        </Button>
      </Stack>
    </Stack>
  );
}
